import { useEffect } from 'react'
import { t } from './ui'

/**
 * Sets <title> with the mandatory "ArkkiKELA (tutkimusmalli)" prefix
 * (DESIGN-BRIEF §3). Pass the page-specific part; the prefix is added here so
 * no page can forget it.
 *
 *   useDocumentTitle('Kansalaiselle')  ->  "ArkkiKELA (tutkimusmalli) — Kansalaiselle"
 *   useDocumentTitle()                 ->  "ArkkiKELA (tutkimusmalli)"
 */
export function useDocumentTitle(pageTitle?: string): void {
  useEffect(() => {
    const prefix = t('site.titlePrefix')
    document.title = pageTitle ? `${prefix} — ${pageTitle}` : prefix
  }, [pageTitle])
}
